import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({ id: 'test-equipments' });

export const equipmentRouteRef = createSubRouteRef({
  id: 'test-equipments-equipment',
  parent: rootRouteRef,
  path: '/equipment',
});
export const hardwareRouteRef = createSubRouteRef({
  id: 'test-equipments-hardware',
  parent: rootRouteRef,
  path: '/hardware',
});
export const assignmentsRouteRef = createSubRouteRef({
  id: 'test-equipments-assignments',
  parent: rootRouteRef,
  path: '/assignments',
});
export const runningSessionsRouteRef = createSubRouteRef({
  id: 'test-equipments-running-sessions',
  parent: rootRouteRef,
  path: '/running-sessions',
});
export const generateCredentialsRouteRef = createSubRouteRef({
  id: 'test-equipments-generate-credentials',
  parent: rootRouteRef,
  path: '/generate-credentials',
});
export const auditRouteRef = createSubRouteRef({
  id: 'test-equipments-audit',
  parent: rootRouteRef,
  path: '/audit',
});
